const TOMBSTONE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
const TOMBSTONE_CAPACITY = 200;

interface Tombstone {
  runId: string;
  dismissedAt: number;
}

function key(serverId: string, userId: string): string {
  return `borgee:activity:background-dismissed:${serverId}:${userId}`;
}

export function readBackgroundRunDismissals(
  serverId: string,
  userId: string,
  now = Date.now(),
): Set<string> {
  return new Set(readTombstones(serverId, userId, now).map(entry => entry.runId));
}

function readTombstones(serverId: string, userId: string, now: number): Tombstone[] {
  if (!serverId || !userId) return [];
  try {
    const parsed = JSON.parse(window.localStorage.getItem(key(serverId, userId)) ?? '[]') as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((entry): entry is Tombstone =>
        typeof entry === 'object'
        && entry !== null
        && typeof (entry as Tombstone).runId === 'string'
        && typeof (entry as Tombstone).dismissedAt === 'number'
        && now - (entry as Tombstone).dismissedAt < TOMBSTONE_TTL_MS)
      .slice(-TOMBSTONE_CAPACITY);
  } catch {
    return [];
  }
}

export function dismissBackgroundRun(
  serverId: string,
  userId: string,
  runId: string,
  now = Date.now(),
): Set<string> {
  const previous = readTombstones(serverId, userId, now).filter(entry => entry.runId !== runId);
  const entries = [...previous, { runId, dismissedAt: now }].slice(-TOMBSTONE_CAPACITY);
  if (!serverId || !userId) return new Set(entries.map(entry => entry.runId));
  try {
    window.localStorage.setItem(key(serverId, userId), JSON.stringify(entries));
  } catch {
    // The caller keeps the returned in-memory set when storage is unavailable.
  }
  return new Set(entries.map(entry => entry.runId));
}
